import Directory from '../../components/directory/directory';

// import './homepage.scss';
import { HomePageContainer } from './homepage_style';

const HomePage = () => (
  <HomePageContainer>
    <Directory />
  </HomePageContainer>
);

export default HomePage;